import { useParams } from "react-router";
import {
  BreadCrumb,
  ApiLoadingSpinner,
  ApiUpdatingSpinner,
  Title,
  ApiRequestError,
} from "@funcional/react-ui";
import { Restricted } from "@funcional/react-auth-ui";
import { ProductCard } from "@pbm/products/components";
import { useProduct } from "@pbm/products/hooks";

export default function ViewProductPage() {
  let { ean }: { ean: string } = useParams();
  const { status, data, error, isFetching } = useProduct(ean);
  return (
    <>
      <div className="flex items-center w-full mb-4">
        <div className="flex-1">
          <Title>Produto #{ean}</Title>
        </div>
      </div>

      <BreadCrumb
        items={[
          {
            path: "/pbm/products",
            label: "Produtos",
          },
          { label: `#${ean}` },
        ]}
      />

      {status === "loading" ? (
        <ApiLoadingSpinner />
      ) : status === "error" ? (
        <ApiRequestError error={error} />
      ) : (
        <>
          {data ? (
            <ProductCard product={data} />
          ) : (
            <p>Política cadastral não encontrada.</p>
          )}
          {isFetching ? <ApiUpdatingSpinner /> : null}
        </>
      )}
    </>
  );
}
